import type { Site } from 'shared/hooks/use-site-detection.types';

export const shouldShowOgpSsoSection = (site: Site, allowOGPSSO: boolean): boolean =>
  site === 'ogp' && allowOGPSSO;
